package one.healthium.onboarding.ui.screens

import androidx.compose.runtime.Composable
import one.healthium.onboarding.domain.configs.SelectableScreenConfig
import one.healthium.onboarding.ui.UserDataProvider
import one.healthium.onboarding.ui.components.SelectableContent
import one.healthium.ui.compose.components.AppScaffold

interface SelectableEventDelegate {
    fun onNextClicked()
    fun onSignInClicked()
}

@Composable
internal fun SelectableScreen(
    eventDelegate: SelectableEventDelegate,
    profileKey: String,
    screenConfig: SelectableScreenConfig,
) {
    UserDataProvider { userState, contract ->
        AppScaffold {
            SelectableContent(
                title = screenConfig.title,
                subtitle = screenConfig.subtitle,
                options = screenConfig.options,
                selectedOptions = userState.additionalInfo[profileKey] ?: emptyList(),
                singleChoice = screenConfig.singleChoice,
                ctaTitle = screenConfig.ctaTitle,
                userState = userState,
                onOptionsChanged = {
                    contract.onAdditionalInfoChanged(profileKey, it)
                },
                onNextClicked = eventDelegate::onNextClicked,
                signInEnabled = screenConfig.signInEnabled,
                onSignInClicked = eventDelegate::onSignInClicked,
                additionalSelectedText = screenConfig.additionalSelectedText,
            )
        }
    }
}
